const swiperReal = new Swiper('.hoox-swiper-real', {
  loop: true,
  slidesPerView: 1,
  slidesPerGroup: 1,
  adaptiveHeight: true,
  effect: 'fade',
  autoHeight: true,
  fadeEffect: {
    crossFade: true,
  },

  breakpoints: {
    768: {
      adaptiveHeight: false
    }
  },

  pagination: {
    el: '.hoox-swiper-real .hoox-swiper-dots',
    clickable: true,
  },

  navigation: {
    nextEl: '.hoox-swiper-real .hoox-swiper-next',
    prevEl: '.hoox-swiper-real .hoox-swiper-prev',
  },
});